import _ from 'lodash'
import Vue from 'vue'
import ApiManager from '../../utils/ApiManager'
import Constants from '@/utils/Constants'
import StringFormat from '@/utils/StringFormat'
import moment from 'moment-ja'
// import ConfigAnalyze from '@/utils/ConfigAnalyze'
import ConditionSetting from '@/utils/ConditionSetting'
import ConfigAnalyze from '../../utils/ConfigAnalyze'

const state = {
  isInit: false,
  loading: false,

  analyzeConfigAll: {}, // 全type(IFxxxxx)の条件
  analyzeConfig: {}, // 現在のtype(IFxxxxx)の条件
  historyId: null,
  errorHistory: {},
  errorInit: false,
  errorAnalyzeRate: 0,
  errorReservationRate: false,
  doneSendAnalyze: false,
  doneCompleteAnalyze: false,
  analyzeError: {
    code: 0,
    message: null
  },
  //  初期データ
  aggregateMaster: [],
  constData: {
    total_display_category: [],
    groupby: [],
    aggregate: []
  },
  //  予約条件
  is_reservation: 0,
  reservation: {},
  reservationNextDate: null,
  //  分析条件
  condition: {},
  groupbyNotice: '',
  groupbyNoticeWithTerm: ''
}

const getters = {
  getType (state) {
    return state.condition.type
  },
  //  指定の分析条件と分析IDから最適な条件を作る
  normalizeCondition: (state, getters) => (condition) => {
    //  analyzeCode(IFxxxxx)の設定取得
    const config = state.analyzeConfig
    let err = []

    //  デフォルト条件に指定条件を上書きマージして全ての条件パラメータを付けておく
    let as = _.cloneDeep(ConfigAnalyze.analyze.condition)
    _.merge(as, condition)
    //  店舗のstatusだけ上書きされてしまうので
    if (condition.shop) {
      as.shop.shop_base.analyze.code_status = condition.shop.shop_base.analyze.code_status
    }

    let ad = _.cloneDeep(ConfigAnalyze.analyze.condition)

    ad.type = as.type

    // -----------------------------------------
    // 会員グループ登録
    if (condition.type === 'IF00000') {
      if (!as.member_group_name) {
        err.push('グループ名が未入力です')
      }
      ad.member_group_id = as.member_group_id
      ad.member_group_name = as.member_group_name
      ad.member_group_tag = as.member_group_tag
      ad.member_group_memo = as.member_group_memo
    }

    // -----------------------------------------
    // 期間 term
    if (config.term_use) {
      if (config.type === 'IF00030') {
        as.term.has_target = 1
        ad.term.has_target = 1
      }
      let td = ad.term
      const ts = as.term
      if (config.term_one_month) {
        //  月のみ指定
        if (!ts.search_term_month) {
          err.push('日時指定の月指定が未入力です')
        }
        td.base_setting = 1
        td.search_term_month = ts.search_term_month
      } else if (config.term_one_monday) {
        //  月曜日のみ指定
        if (!ts.search_term_newitem) {
          err.push('日時指定の日付指定が未入力です')
        }
        td.base_setting = 1
        td.search_term_newitem = ts.search_term_newitem
      } else {
        //  日付の範囲条件
        const obj = Constants.getPosDate()
        const dateLimit = {
          min: null,
          max: null
        }
        if (obj) {
          dateLimit.min = StringFormat.ymdFormat(obj.pos_date_from)
          dateLimit.max = StringFormat.ymdFormat(obj.pos_date_to)
        }

        let errPanel = '基準日時の'
        //  モード
        td.base_setting = ts.base_setting
        //  from to
        if ((config.term_month_from_to && td.base_setting === 1) || (config.term_from_to && td.base_setting === 1) ||
          (config.term_week && td.base_setting === 2)) {
          let from, to
          if (ts.search_term_base) {
            from = ts.search_term_base.from
            to = ts.search_term_base.to
          } else {
            from = null
            to = null
          }
          if (config.term_month_from_to) {
            if (from && from.length === 7) {
              from = from + '-01'
            }
            if (to && to.length === 7) {
              to = to + '-01'
            }
          }
          if (!(from && to)) {
            err.push(errPanel + '期間が未入力です')
          } else if (moment(from).isBetween(dateLimit.min, dateLimit.max, null, '[]') === false) {
            if (!state.reservationNextDate) {
              err.push(errPanel + 'データ搭載期間外です')
            }
          } else if (moment(to).isBetween(dateLimit.min, dateLimit.max, null, '[]') === false) {
            if (!state.reservationNextDate) {
              err.push(errPanel + 'データ搭載期間外です')
            }
          } else if (moment(from).isSameOrBefore(to, 'day') === false) {
            err.push(errPanel + '期間指定が不正です')
          }
          td.search_term_base = {
            from: from,
            to: to
          }
        }
        //  曜日
        if (config.term_week && td.base_setting === 2) {
          if (!ts.search_term_base_box || ts.search_term_base_box.length === 0) {
            err.push(errPanel + '曜日絞り込みの決定日付がありません')
            td.search_term_base_weeks = ts.search_term_base_weeks
            td.search_term_base_box = []
          } else {
            td.search_term_base_weeks = ts.search_term_base_weeks
            td.search_term_base_box = ts.search_term_base_box
          }
        }
        //  リスト
        if (config.term_dates && td.base_setting === 3) {
          if (!ts.search_term_base_dates || ts.search_term_base_dates.length === 0) {
            err.push(errPanel + '日付指定リストが未入力です')
            td.search_term_base_dates = []
          } else {
            td.search_term_base_dates = ts.search_term_base_dates
          }
        }
        //  比較日時
        //  まず、併売のモードでtargetがありあえるか確認
        let targetBeforeAfter = false
        if (config.term_type_mode) {
          if (as.type_mode === 1 || as.type_mode === 2) {
            targetBeforeAfter = true
            ad.type_mode = as.type_mode
          } else {
            ad.type_mode = 0
          }
        } else {
          ad.type_mode = 0
        }

        if (config.term_target || targetBeforeAfter) {
          if (ts.has_target === 1) {
            errPanel = '比較日時の'
            //  from to
            const from = ts.search_term_target.from
            const to = ts.search_term_target.to
            if (!(from && to)) {
              err.push(errPanel + '期間が未入力です')
            } else if (moment(from).isBetween(dateLimit.min, dateLimit.max, null, '[]') === false) {
              if (!state.reservationNextDate) {
                err.push(errPanel + 'データ搭載期間外です')
              }
            } else if (moment(to).isBetween(dateLimit.min, dateLimit.max, null, '[]') === false) {
              if (!state.reservationNextDate) {
                err.push(errPanel + 'データ搭載期間外です')
              }
            } else if (moment(from).isSameOrBefore(to, 'day') === false) {
              err.push(errPanel + '期間指定が不正です')
            }
            td.has_target = 1
            td.search_term_target = {
              from: from,
              to: to
            }
          } else {
            td.has_target = 0
          }
        }
        //  基準と比較の以後以前チェック
        if (td.has_target) {
          const fromB = td.search_term_base.from
          const fromT = td.search_term_target.from
          if (fromB && fromT) {
            if (ad.type_mode === 1 || ad.type === 'IF00030') {
              // 分析モード「直前期間購入者分析」
              // 基準日時＞比較日時ならOK、基準日時≦比較日時ならエラー
              if (moment(fromT).isSameOrAfter(fromB, 'day')) {
                err.push('比較開始日は基準開始日より前に設定してください')
              }
            } else if (ad.type_mode === 2) {
              //  基準日時＜比較日時ならOK、基準日時≧比較日時ならエラー
              if (moment(fromB).isSameOrAfter(fromT, 'day')) {
                err.push('比較開始日は基準開始日より後に設定してください')
              }
            }
            // それ以外type_mode===0の場合、比較期間が自動設定なので、チェックしない
          }
          const toB = td.search_term_base.to
          const toT = td.search_term_target.to
          if (toB && toT) {
            if (ad.type_mode === 1 || ad.type === 'IF00030') {
              // 分析モード「直前期間購入者分析」
              // 基準日時＞比較日時ならOK、基準日時≦比較日時ならエラー
              if (moment(toT).isSameOrAfter(toB, 'day')) {
                err.push('比較終了日は基準終了日より前に設定してください')
              }
            } else if (ad.type_mode === 2) {
              // 分析モード「直後期間購入者分析」
              //  基準日時＜比較日時ならOK、基準日時≧比較日時ならエラー
              if (moment(toB).isSameOrAfter(toT, 'day')) {
                err.push('比較終了日は基準終了日より後に設定してください')
              }
            }
            // それ以外type_mode===0の場合、比較期間が自動設定なので、チェックしない
          }
        }
      }
      //  買上時間
      let from, to
      if (config.term_time && td.has_target === 0) {
        if (ts.search_term_base_time) {
          from = ts.search_term_base_time.from
          to = ts.search_term_base_time.to
        } else {
          from = null
          to = null
        }
        if (from && to) {
          let tfrom = '2000/01/01 ' + from
          let tto = '2000/01/01 ' + to
          if (moment(tto).isSameOrBefore(tfrom, 'minute')) {
            err.push('買上時間の範囲が不正です')
            from = null
            to = null
            td.has_base_time = 0
          } else {
            td.has_base_time = 1
          }
        } else {
          if (from || to) {
            err.push('買上時間は範囲を入力してください')
          }
          from = null
          to = null
          td.has_base_time = 0
        }
        td.search_term_base_time = {
          from: from,
          to: to
        }
      } else {
        td.has_base_time = 0
      }
    }

    // -----------------------------------------
    // 商品 product
    if (config.product_use) {
      let pd = ad.product
      const ps = as.product

      // codeをvuetify obj からkey配列にするkey
      let keyName
      if (ps.code_pattern === 2) {
        keyName = 'jancd'
      } else {
        keyName = 'item_code'
      }

      let flags = {
        code_pattern: 2
      }

      if (config.product_code_item) {
        pd.code_pattern = ps.code_pattern
      }

      pd.contract_flag = ps.contract_flag

      flags.code_pattern = pd.code_pattern
      // baseの最適化------------------------------
      getters.normalizeProductPanel(ps.item_base, pd.item_base, flags, config)
      if (pd.item_base.analyze.is_all === 0 && ps.item_base_code.length === 0) {
        if ((ps.item_base.analyze.mode === 'category' && !ps.item_base.analyze.category.noSubmit) ||
            (ps.item_base.analyze.mode === 'category_group' && !ps.item_base.analyze.category_group.noSubmit) ||
            (ps.item_base.analyze.mode === 'product_attribute' && !ps.item_base.analyze.product_attribute.noSubmit)) {

        } else {
          err.push('基準商品の選択がありません。')
        }
      } else {
        if (ps.item_base_code.length > 0) {
          pd.item_base_code = _.map(ps.item_base_code, keyName)
          pd.item_base_code = _.uniq(pd.item_base_code)
        }
      }

      // targetの最適化---------------------------
      if (config.product_target) {
        pd.has_target = 1
        getters.normalizeProductPanel(ps.item_target, pd.item_target, flags, config)
        if (pd.item_target.analyze.is_all === 0 && ps.item_target_code.length === 0) {
          if ((ps.item_target.analyze.mode === 'category' && !ps.item_target.analyze.category.noSubmit) ||
              (ps.item_target.analyze.mode === 'category_group' && !ps.item_target.analyze.category_group.noSubmit) ||
              (ps.item_target.analyze.mode === 'product_attribute' && !ps.item_target.analyze.product_attribute.noSubmit)) {

          } else {
            err.push('比較商品の選択がありません。')
          }
        } else {
          if (ps.item_target_code.length > 0) {
            pd.item_target_code = _.map(ps.item_target_code, keyName)
            pd.item_target_code = _.uniq(pd.item_target_code)
          }
        }
      }

      // togetherの最適化---------------------------
      if (config.type === 'IF00000' && ps.item_together.conditions.length > 0) {
        pd.count_together = 0
        pd.item_together = {
          conditions: []
        }
        for (let i = 0; i < ps.item_together.conditions.length; i++) {
          let titem = ps.item_together.conditions[i]

          //  デフォルト条件に指定条件を上書きマージして全ての条件パラメータを付けておく
          let tos = _.cloneDeep(ConfigAnalyze.togetherCondition)
          _.merge(tos, titem)
          let tod = _.cloneDeep(ConfigAnalyze.togetherCondition)
          let tosa = {
            analyze: tos.analyze
          }
          let toda = {
            analyze: tod.analyze
          }

          getters.normalizeProductPanel(tosa, toda, flags, config)

          if (tod.analyze.is_all === 0 && tos.code.length === 0) {
            if ((tos.analyze.mode === 'category' && !tos.analyze.category.noSubmit) ||
                (tos.analyze.mode === 'category_group' && !tos.analyze.category_group.noSubmit) ||
                (tos.analyze.mode === 'product_attribute' && !tos.analyze.product_attribute.noSubmit)) {
              pd.item_together.conditions.push(tod)
              pd.count_together++
            } else {
              // err.push('併売商品の選択がありません。')
            }
          } else {
            if (tos.code.length > 0) {
              if (tos.code[0][keyName]) {
                tod.code = _.map(tos.code, keyName)
                tod.code = _.uniq(tod.code)
              }
            }
            pd.item_together.conditions.push(tod)
            pd.count_together++
          }
        }
        if (pd.count_together > 0) {
          pd.has_together = 1
        }
      }
    }

    // -----------------------------------------
    // 店舗 shop
    if (config.shop_use) {
      let sad = ad.shop.shop_base.analyze
      const sas = as.shop.shop_base.analyze

      sad.mode = sas.mode

      if (sas.is_all === 1) {
        sad.is_all = 1
        sad.mode = 'all'
      } else {
        sad.is_all = 0
        if (sas.mode === 'group') {
          sad.group = sas.group
        } else if (sas.mode === 'category') {
          sad.category = sas.category
        } else if (sas.mode === 'code') {
          sad.code = sas.code
        } else if (sas.mode === 'name') {
          sad.namse = sas.name
        } else if (sas.mode === 'file') {
          sad.file_name = sas.file_name
          sad.file = sas.file
        } else if (sas.mode === 'freeword') {
          sad.freeword = sas.freeword
          sad.freeword_code = sas.freeword_code
        } else {
          sad.mode = ''
        }
      }

      //  エリア選択
      if (config.shop_area) {
        sad.shop_area_code = sas.shop_area_code
        if (sad.shop_area_code === null) {
          //  選択がない場合、最初のエリアを選択しておく
          if (state.constData.shop_area && state.constData.shop_area.length > 0) {
            sad.shop_area_code = state.constData.shop_area[0].code
          } else {
            sad.shop_area_code = null
          }
        }
      } else {
        sad.shop_area_code = null
      }

      sad.code_status = sas.code_status
      sad.code_exclude = sas.code_exclude

      const code = as.shop.shop_base_code

      let filter = []
      for (let i = 0; i < code.length; i++) {
        const item = code[i]
        if (!config.shop_area || item.shop_area_code === sad.shop_area_code) {
          for (let s = 0; s < sad.code_status.length; s++) {
            if (item.status === sad.code_status[s]) {
              filter.push(item)
            }
          }
        }
      }
      if (filter.length === 0) {
        err.push('店舗の選択がありません。')
      } else {
        filter = _.map(filter, 'shop_cd')
        ad.shop.shop_base_code = _.uniq(filter)
      }
    }

    // ------------------------------------
    // 顧客・会員 member
    if (config.member_use) {
      let md = ad.member
      const ms = as.member

      if (config.member_mask) {
        md.mask_flag = ms.mask_flag
      } else if (Constants.getUser('member_id_flag') === 3) {
        md.mask_flag = 0
      } else if (Constants.getUser('member_id_flag') !== 2) {
        md.mask_flag = 1
      }
      if (config.member_type_member_only) {
        if (config.member_type_non_include) {
          if (ms.non_member === null) {
            if (config.type === 'IF00001') {
              md.non_member = 1
            } else {
              md.non_member = 0
            }
          } else {
            md.non_member = ms.non_member
          }
        }
        if (config.member_type_non_only) {
          md.non_member_only = ms.non_member_only
        }
      }

      if (config.member_group && ms.mode === 'group') {
        if (ms.member_ids.analyze.group.length === 0) {
          md.mode = 'detail'
        } else {
          md.mode = ms.mode
          md.member_ids.analyze.group = ms.member_ids.analyze.group
        }
      } else if (config.member_code && ms.mode === 'code') {
        if (ms.member_ids.analyze.code.length === 0) {
          err.push('会員番号の指定がありません。')
        } else {
          md.mode = ms.mode
          md.member_ids.analyze.code = ms.member_ids.analyze.code
        }
      } else if (config.member_file && ms.mode === 'file') {
        if (ms.member_ids.analyze.file_name) {
          md.mode = ms.mode
          md.member_ids.analyze.file_name = ms.member_ids.analyze.file_name
          if (ms.member_ids.analyze.file.length) {
            md.member_ids.analyze.file = ms.member_ids.analyze.file
          }
        } else {
          err.push('会員ファイルの指定がありません。')
        }
      } else if (ms.mode === 'detail') {
        md.mode = ms.mode
      }
      if (config.member_gender) {
        md.gender = ms.gender
      }
      if (config.member_age) {
        if (ms.age_target === 5 || ms.age_target === 10) {
          if (ms.age_code.length > 0) {
            md.age_target = ms.age_target
            md.age_code = ms.age_code
          } else {
            err.push('会員条件の年代の選択がありません')
          }
        }
      }
      if (config.member_decile) {
        if (ms.decile.from && ms.decile.to && (ms.decile.from > ms.decile.to)) {
          err.push('会員条件のデシルの範囲が不正です。')
        } else {
          md.decile = ms.decile
        }
      }
      if (config.member_rank) {
        ms.rank.from = ms.rank.from - 0
        ms.rank.to = ms.rank.to - 0
        if (ms.rank.from && ms.rank.to && (ms.rank.from > ms.rank.to)) {
          err.push('会員条件のランクの範囲が不正です。')
        } else if ((ms.rank.from || ms.rank.to) && !ms.rank_month) {
          err.push('会員条件のランク対象月の指定がありません')
        } else {
          md.rank = ms.rank
          if (ms.rank.from || ms.rank.to) {
            md.rank_month = ms.rank_month
          }
        }
      }
      if (config.member_quantity) {
        let from = ms.quantity.from - 0
        let to = ms.quantity.to - 0
        if (ms.quantity.from && ms.quantity.to && (from > to)) {
          err.push('会員条件の買上点数の範囲が不正です。')
        } else {
          md.quantity = ms.quantity
        }
      }
      if (config.member_amount) {
        let from = ms.amount.from - 0
        let to = ms.amount.to - 0
        if (ms.amount.from && ms.amount.to && (from > to)) {
          err.push('会員条件の買上金額の範囲が不正です。')
        } else {
          md.amount = ms.amount
        }
      }
      if (config.member_visit) {
        let from = ms.visit.from - 0
        let to = ms.visit.to - 0
        if (ms.visit.from && ms.visit.to && (from > to)) {
          err.push('会員条件の来店回数の範囲が不正です。')
        } else {
          md.visit = ms.visit
        }
      }
      if (config.member_gross) {
        let from = ms.gross.from - 0
        let to = ms.gross.to - 0
        if (ms.gross.from && ms.gross.to && (from > to)) {
          err.push('会員条件の粗利額の範囲が不正です。')
        } else {
          md.gross = ms.gross
        }
      }
      if (config.member_card) {
        md.card = ms.card
      }
      if (config.member_payment) {
        md.payment = ms.payment
      }
      if (config.member_basket) {
        let from = ms.basket_price.from - 0
        let to = ms.basket_price.to - 0
        if (ms.basket_price.from && ms.basket_price.to && (from > to)) {
          err.push('会員条件のバスケット金額指定の範囲が不正です。')
        } else {
          md.basket_price = ms.basket_price
        }
      }
      // 会員除外モード
      if (String(ms.exclude_flag) === '1' && (ms.mode === 'group' || ms.mode === 'code' || ms.mode === 'file')) {
        md.exclude_flag = '1'
      }
    } else {
      ad.member.mode = 'detail'
    }

    // ------------------------------------
    // 価格設定
    if (config.output_price_range) {
      let from = as.price_range.from - 0
      let to = as.price_range.to - 0
      if ((as.price_range.from && as.price_range.to) && from > to) {
        err.push('価格設定の価格帯の範囲が不正です。')
      } else {
        ad.price_range = as.price_range
      }
      ad.price_range_step = as.price_range_step
    }

    if (config.value_groupby_group_target && ad.term.has_target) {
      if (condition.type in Constants.GroupByLimitGroupWithTerm) {
        const checks = Constants.GroupByLimitGroupWithTerm[condition.type]
        const hit = as.groupby.filter((val) => {
          return checks.some((column) => {
            return val === column
          })
        })
        if (hit.length !== 1) {
          err.push('集約項目の ' + state.groupbyNoticeWithTerm + 'の中から1つだけ選択してください。')
        } else {
          ad.groupby = as.groupby
        }
      }
    }
    if (config.value_minimum_one) {
      if (as.groupby.length === 0 && as.aggregate.length === 0) {
        err.push('集約項目と集計項目から最低限1つ選択してください')
      } else {
        ad.groupby = as.groupby
        ad.aggregate = as.aggregate
      }
    } else {
      if (config.value_groupby_use) {
        if (config.value_groupby_group) {
          if (condition.type in Constants.GroupByLimitGroup) {
            let hits = false
            const checkGroup = Constants.GroupByLimitGroup[condition.type]
            for (let g = 0; g < checkGroup.length; g++) {
              const hit = as.groupby.some((val) => {
                return checkGroup[g].some((column) => {
                  return val === column
                })
              })
              if (!hit) {
                err.push('集約項目の ' + state.groupbyNotice[g] + 'から、1つ以上選択してください')
              }
              hits = hits || hit
            }
            if (hits) {
              ad.groupby = as.groupby
            }
          }
        } else {
          if (as.groupby.length === 0 && config.value_groupby_required) {
            err.push('集約項目から最低限1つ選択してください')
          } else {
            ad.groupby = as.groupby
          }
        }
      }
      if (config.value_aggregate_use) {
        if (as.aggregate.length === 0) {
          err.push('集計項目から最低限1つ選択してください')
        } else {
          ad.aggregate = as.aggregate
        }
      }
    }

    if (config.output_age_reference) {
      ad.age_reference = as.age_reference
    }
    if (config.output_zero) {
      ad.zero_data_flag = as.zero_data_flag
    }
    if (config.output_graph) {
      ad.graph_setting = as.graph_setting
    }
    if (config.output_publish) {
      ad.publish_setting = as.publish_setting
    }
    if (config.output_total_display) {
      ad.total_display = as.total_display
    }

    console.log('normalizeCondition:end', {
      condition: ad,
      errors: err
    })
    return {
      condition: ad,
      errors: err
    }
  },
  //  指定の分析条件と分析IDから最適な条件を作る
  normalizeProductPanel: (state) => (itemSrc, itemDst, flags, config) => {
    let pd = itemDst.analyze
    const ps = itemSrc.analyze

    pd.mode = ps.mode

    if (ps.is_all === 1) {
      pd.is_all = 1
      pd.mode = ''
    } else {
      pd.is_all = 0
      if (ps.mode === 'code') {
        pd.code = ps.code
      } else if (ps.mode === 'file') {
        pd.file_name = ps.file_name
        pd.file = ps.file
      } else if (ps.mode === 'group') {
        pd.group = ps.group
      } else if (ps.mode === 'category' && config.product_category) {
        pd.category = ps.category
      } else if (ps.mode === 'category_group' && config.product_category_group) {
        pd.category_group = ps.category_group
      } else if (ps.mode === 'product_attribute' && config.product_attribute && flags.code_pattern === 2) {
        pd.product_attribute = ps.product_attribute
      } else if (ps.mode === 'freeword') {
        pd.freeword = ps.freeword
        pd.freeword_code = ps.freeword_code
      } else {
        pd.mode = ''
      }

      pd.code_exclude = ps.code_exclude

      if (flags.code_pattern === 1 && (config.product_area || pd.mode === 'category' || pd.mode === 'category_group')) {
        pd.product_area_code = ps.product_area_code
        if (pd.product_area_code === null) {
          //  選択がない場合、最初のエリアを選択しておく
          if (state.constData.product_area && state.constData.product_area.length > 0) {
            pd.product_area_code = state.constData.product_area[0].code
          } else {
            pd.product_area_code = null
          }
        }
      }
    }

    return {
      analyze: pd
    }
  }
}

const actions = {
  //  CSV設定から分析のパターンを連想配列へ
  initConfig ({ state, commit }) {
    let config = {}
    const line = ConditionSetting.getCSV().split('\n')

    //  header line = IF000xx
    let IFs = line[0].split(',')
    for (let h = 1; h < IFs.length; h++) {
      const IFno = IFs[h]
      config[IFno] = {}
    }
    //  config[IF00000][param] = true 形式に変換
    for (let i = 1; i < line.length; i++) {
      let items = line[i].split(',')
      for (let h = 1; h < IFs.length; h++) {
        if (items[0]) {
          const IFno = IFs[h]
          const param = items[0]
          config[IFno][param] = (items[h] === '1')
        }
      }
    }
    commit('initConfig', config)
  },
  async getData ({ state, commit, getters }, payload) {
    const analyzeType = payload.analyzeType
    commit('setType', analyzeType)

    let historyId = payload.historyId
    let memberGroupId = payload.memberGroupId

    commit('setErrorHistory', { status: false, historyId: historyId })
    commit('setErrorInit', false)
    commit('setLoading', true)
    commit('setErrorAnalyzeRate', 0)
    commit('setErrorReservationRate', false)

    //  条件のプロパティをリアクティブに初期化
    commit('initCondition')

    const param = {
      code: analyzeType
    }

    //  ページ初期データ読み込み
    let resConst = await ApiManager.request('Analyze').analyzeInit(param)
    if (resConst.data.code !== 200000) {
      console.log('分析は利用できません')
      commit('setErrorInit', true)
      return
    }

    // 月間分析比率によって画面制御を行う
    const monthlyAnalyzeRate = resConst.data.data.monthly_analyze_rate
    if (monthlyAnalyzeRate.monthly_analyze_usage_rate >= 1.0 || monthlyAnalyzeRate.monthly_analyze_count_rate >= 1.0) {
      // 分析条件画面を開いたタイミングで、月間の分析従量が分析可能従量を上回っていた場合、制限
      commit('setErrorAnalyzeRate', 2)
      return
    } else if ((monthlyAnalyzeRate.monthly_analyze_usage_rate >= 0.9 && monthlyAnalyzeRate.monthly_analyze_usage_rate < 1.0) ||
      (monthlyAnalyzeRate.monthly_analyze_count_rate >= 0.9 && monthlyAnalyzeRate.monthly_analyze_count_rate < 1.0)) {
      // 分析条件画面を開いたタイミングで、分析可能従量が１割を切っていた場合、警告
      commit('setErrorAnalyzeRate', 1)
    }
    const reservationRate = resConst.data.data.reservation_rate
    if (reservationRate.reservation_count_rate >= 1.0) {
      // (都度)閾値を超過していた場合、各分析メニューの「予約」ラジオボタンを押下時、制限
      commit('setErrorReservationRate', true)
    }

    //  ページデータcommit
    commit('setConstData', resConst.data.data)

    if (analyzeType in Constants.GroupByLimitGroup) {
      //  最低一つ選択する、そのエラーメッセージを作っておく
      let msgs = []
      const group = Constants.GroupByLimitGroup[analyzeType]
      for (let g = 0; g < group.length; g++) {
        let msg = []
        const checks = group[g]
        for (let i = 0; i < checks.length; i++) {
          state.constData.groupby.some((item) => {
            if (item.column === checks[i]) {
              msg.push(item.name)
              return true
            }
            return false
          })
        }
        msg = msg.join('、')
        msgs.push(msg)
      }
      commit('setGroupbyNotice', msgs)
    }

    if (analyzeType in Constants.GroupByLimitGroupWithTerm) {
      //  1つのみ選択する、そのエラーメッセージを作っておく
      let msgs = []
      const checks = Constants.GroupByLimitGroupWithTerm[analyzeType]
      for (let i = 0; i < checks.length; i++) {
        state.constData.groupby.some((item) => {
          if (item.column === checks[i]) {
            msgs.push(item.name)
            return true
          }
          return false
        })
      }
      commit('setGroupbyNoticeWithTerm', msgs.join('、'))
    }
    //  商品初期データcommit
    this.dispatch('productcondition/setConstData', resConst.data.data, { root: true })
    //  店舗初期データcommit
    this.dispatch('shopcondition/setConstData', resConst.data.data, { root: true })
    //  顧客初期データcommit
    this.dispatch('membercondition/setConstData', resConst.data.data, { root: true })

    let isRestore = false
    let resCondition = {}
    let lsdata

    //  分析条件初期化
    if (historyId !== null) {
      //  分析履歴から読み込み
      const resHistory = await ApiManager.request('History').historyDetail(historyId)
      if (resHistory.data.code !== 200000) {
        console.log('分析条件を履歴から読み込み: error')
        //  読み込みエラー
        commit('setErrorHistory', { status: true, historyId: historyId })
        historyId = null
        console.log('分析条件をデフォルトで初期化')
      } else {
        resCondition = resHistory.data.data.conditions
        console.log('分析条件を履歴から読み込み:', resCondition)
        isRestore = true
      }
    } else if (memberGroupId !== null) {
      //  分析履歴から読み込み
      const resGroup = await ApiManager.request('MemberGroup').memberGroupDetail(memberGroupId)
      if (resGroup.data.code !== 200000) {
        console.log('会員グループ編集読み込み error:id:', memberGroupId)
      } else {
        const resHistory = await ApiManager.request('History').historyDetail(resGroup.data.data.history_id)
        if (resHistory.data.code !== 200000) {
          console.log('会員グループの分析条件を履歴から読み込み: error')
          //  読み込みエラー
          commit('setErrorHistory', { status: true, historyId: historyId })
          historyId = null
          console.log('分析条件をデフォルトで初期化')
        } else {
          resCondition = resHistory.data.data.conditions
          resCondition.member_group_id = memberGroupId
          console.log('会員グループの分析条件を履歴から読み込み:', resCondition)
          isRestore = true
        }
      }
    } else if (analyzeType === 'IF00000') {
      console.log('分析条件をデフォルトで初期化(IF00000)')
      resCondition = {
        type: analyzeType
      }
    } else {
      // LocalStorageのチェック
      lsdata = JSON.parse(Vue.localStorage.get('analyze'))
      if (lsdata) {
        resCondition = lsdata
        console.log('分析条件をLocalStorageから読み込み', resCondition)
        isRestore = true
      } else {
        console.log('分析条件をデフォルトで初期化')
        resCondition = {
          type: analyzeType
        }
      }
    }

    //  分析条件最適化
    const normalized = getters.normalizeCondition(resCondition)
    let condition = normalized.condition

    //  復元にはcodeは使わないので初期化
    if (isRestore) {
      condition.type = analyzeType
      condition.product.item_base_code = []
      condition.product.item_target_code = []
      let togethers = condition.product.item_together.conditions
      for (let i = 0; i < togethers.length; i++) {
        togethers[i].code = []
      }
      condition.shop.shop_base_code = []
    }

    // 顧客指定のデフォルトを「会員条件から指定」(group)にする
    if (state.analyzeConfig.member_group) {
      if (!isRestore) {
        // 初期表示時は常にgroupをデフォルトにする
        condition.member.mode = 'group'
      } else if (
        condition.member.mode === 'detail' &&
        condition.member.member_ids.analyze.group.length === 0 &&
        condition.member.member_ids.analyze.code.length === 0 &&
        !condition.member.member_ids.analyze.file_name
      ) {
        // 復元時、顧客指定が未指定の場合はgroupをデフォルトにする
        condition.member.mode = 'group'
      }
    }

    commit('setCondition', condition)
    if (state.analyzeConfig.term_type_mode) {
      commit('setTypeMode', condition.type_mode)
    }

    if (isRestore) {
      //  商品カートの再現をして保存
      this.dispatch('productcondition/setHistoryCondition', condition.product, { root: true })
      //  店舗カートの再現をして保存
      this.dispatch('shopcondition/setHistoryCondition', condition.shop, { root: true })
    } else {
      //  初期パラメータ
      this.dispatch('productcondition/setCondition', condition.product, { root: true })
      this.dispatch('shopcondition/setCondition', condition.shop, { root: true })
    }
    //  顧客分析再現パラメータ
    this.dispatch('membercondition/setCondition', condition.member, { root: true })

    //  デフォルトの会員条件を算出して保持（「※会員条件設定中」表示判定用）
    const defaultNormalized = getters.normalizeCondition({ type: analyzeType })
    this.dispatch('membercondition/setDefaultCondition', defaultNormalized.condition.member, { root: true })

    commit('setLoading', false)
  },
  async analyzeStart ({ state, commit }, param) {
    commit('setLoading', true)
    commit('setDoneCompleteAnalyze', false)
    commit('setDoneSendAnalyze', false)

    //  送信、保存用に、除外リストをcodeから除外
    //  product base
    let cp = param.analyze.product
    if (cp.item_base.analyze.code_exclude.length > 0) {
      cp.item_base_code = _.difference(cp.item_base_code, cp.item_base.analyze.code_exclude)
    }
    //  product target
    if (cp.item_target.analyze.code_exclude.length > 0) {
      cp.item_target_code = _.difference(cp.item_target_code, cp.item_target.analyze.code_exclude)
    }
    //  product together
    let to = param.analyze.product.item_together.conditions
    for (let i = 0; i < to.length; i++) {
      if (to[i].analyze.code_exclude.length > 0) {
        to[i].code = _.difference(to[i].code, to[i].analyze.code_exclude)
      }
    }
    //  shop base
    let cs = param.analyze.shop
    if (cs.shop_base.analyze.code_exclude.length > 0) {
      cs.shop_base_code = _.difference(cs.shop_base_code, cs.shop_base.analyze.code_exclude)
    }

    //  分析開始
    console.log('Analyze Start', param)

    const res = await ApiManager.request('Analyze').analyzeStart(param)
    console.log('Analyze End', res)
    commit('setLoading', false)

    let error = {
      id: null,
      code: 200000,
      message: null
    }
    if (res.data.code === 200000) {
      error.id = res.data.data.id
      //  LocalStrageに保存
      //  codeを空にする
      param.analyze.product.item_base_code = []
      param.analyze.product.item_target_code = []

      param.analyze.product.has_together = 0
      param.analyze.product.count_together = 0
      param.analyze.product.item_together.conditions = []

      param.analyze.shop.shop_base_code = []

      Vue.localStorage.set('analyze', JSON.stringify(param.analyze))
    } else {
      error.code = res.data.code
      error.message = res.data.data.message
    }
    commit('setAnalyzeError', error)
    commit('setDoneSendAnalyze', true)
  },
  async checkDoneAnalyze ({ state, commit }, id) {
    const res = await ApiManager.request('History').historyDetail(id)

    let error = {
      id: id,
      code: 200000,
      message: null
    }

    if (res.data.code === 200000) {
      if (res.data.data.status === 2) {
        if (res.data.data.analyze_error !== '') {
          error.message = res.data.data.analyze_error
          commit('setAnalyzeError', error)
        }
        commit('setDoneCompleteAnalyze', true)
      }
    } else {
      error.code = res.data.code
      error.message = res.data.data.message
      commit('setAnalyzeError', error)
      commit('setDoneCompleteAnalyze', true)
    }
  }
}

const mutations = {
  initConfig (state, data) {
    state.analyzeConfigAll = data
    console.log('initConfig:', state.analyzeConfigAll)
  },
  setIsInit (state, data) {
    state.isInit = data
  },
  setLoading (state, data) {
    state.loading = data
    if (data) {
      this.dispatch('loading/loadingPagePlus')
    } else {
      this.dispatch('loading/loadingPageMinus')
    }
  },
  setErrorHistory (state, data) {
    state.errorHistory = data
  },
  setErrorInit (state, data) {
    state.errorInit = data
  },
  setErrorAnalyzeRate (state, data) {
    state.errorAnalyzeRate = data
  },
  setErrorReservationRate (state, data) {
    state.errorReservationRate = data
  },
  setDoneSendAnalyze (state, data) {
    state.doneSendAnalyze = data
  },
  setDoneCompleteAnalyze (state, data) {
    state.doneCompleteAnalyze = data
  },
  setAnalyzeError (state, data) {
    state.analyzeError = data
  },
  initCondition (state) {
    state.condition = Object.assign({}, _.cloneDeep(ConfigAnalyze.analyze.condition))
  },
  setCondition (state, data) {
    state.condition = data
  },
  setConstData (state, data) {
    Object.keys(data).forEach(
      key => {
        if (key in data) {
          state.constData[key] = data[key]
        } else {
          state.constData[key] = []
        }
      }
    )
    state.aggregateMaster = _.cloneDeep(state.constData.aggregate)
  },
  setTermTarget (state, data) {
    state.condition.term.has_target = data
  },
  setMemberGroupInfoFromDb (state, data) {
    state.condition.member_group_id = data.id
    state.condition.member_group_name = data.name
    state.condition.member_group_tag = data.tag
    state.condition.member_group_memo = data.memo
    state.condition.member_group_publish_setting = data.publish_setting_
  },
  setReservation (state, data) {
    state.is_reservation = data.is_reservation
    state.reservation = data.reservation
  },
  setIsReservation (state, data) {
    state.is_reservation = data
    //  configの書き換え
    const org = state.analyzeConfigAll[state.condition.type].output_publish
    if (org) {
      if (state.is_reservation === 1 && Constants.getContract('reservation_publish_setting_flag') === 1) {
        state.analyzeConfig.output_publish = true
      } else {
        state.analyzeConfig.output_publish = false
      }
      if (state.is_reservation === 0 && Constants.getContract('history_publish_setting_flag') === 1) {
        state.analyzeConfig.output_publish = true
      } else {
        state.analyzeConfig.output_publish = false
      }
    }

    if (data !== 1) {
      state.reservationNextDate = null
    }
  },
  setReservationNextDate (state, data) {
    state.reservationNextDate = data
  },
  setType (state, data) {
    state.condition.type = data
    let config = _.cloneDeep(state.analyzeConfigAll[data])
    if (config) {
      config.type = data

      //  商品利用
      if (config.product_use && Constants.getContract('product_attribute_use') === 3) {
        config.product_attribute = true
      } else {
        config.product_attribute = false
      }
      //  利用コード選択
      if (config.product_code_item && Constants.getSite('is_item_use') === '1' && Constants.getUser('product_flag') === 1) {
      } else {
        config.product_code_item = false
      }
      //  自社商品
      const division = Constants.getContract('division')
      if (config.product_sel_contract && (division === 3 || division === 4)) {
      } else {
        config.product_sel_contract = false
      }
      //  商品エリア
      if (config.product_area && Constants.getSite('is_item_use') === '1') {
      } else {
        config.product_area = false
      }
      //  商品カテゴリー、カテゴリーグループ
      const pqty = Constants.getSite('product_category_rank_qty')
      if (pqty && pqty - 0) {
        config.product_category = true
      } else {
        config.product_category = false
      }
      config.product_category_group = true

      //  店舗エリア
      const at = Constants.getAnalyzeTarget(data)
      if (at && config.shop_area && at.pos_flag === 2 && Constants.getSite('is_shoparea_use') === '1') {
      } else {
        config.shop_area = false
      }

      //  会員ファイル
      const memberIdFlag = Constants.getUser('member_id_flag')
      if (config.member_file && (memberIdFlag !== 0)) {
      } else {
        config.member_file = false
      }
      //  会員コード
      if (config.member_code && (memberIdFlag !== 0)) {
      } else {
        config.member_code = false
      }
      //  マスキングした会員番号を使用する
      if (config.member_mask && memberIdFlag === 2) {
      } else {
        config.member_mask = false
      }
      //  カード
      if (config.member_card && Constants.getContract('card_flag') === 1) {
      } else {
        config.member_card = false
      }
      //  性別
      if (config.member_gender && Constants.getUser('age_gender_flag') === 1) {
      } else {
        if (data === 'IF00006' || data === 'IF00007') {
          config.member_gender = false
        }
      }
      //  年代
      if (config.member_age && Constants.getUser('age_gender_flag') === 1) {
      } else {
        if (data === 'IF00006' || data === 'IF00007') {
          config.member_age = false
        }
      }
      //  デシル
      if (config.member_decile && Constants.getUser('decil_flag') === 1) {
      } else {
        config.member_decile = false
      }
      //  ランク
      if (config.member_rank && Constants.getUser('rank_flag') === 1) {
      } else {
        config.member_rank = false
      }
      //  決済区分
      if (config.member_payment && Constants.getContract('payment_flag') === 1) {
      } else {
        config.member_payment = false
      }
      //  粗利
      if (config.member_gross && Constants.getContract('gross_flag') === 1) {
      } else {
        config.member_gross = false
      }
      //  会員条件は使用するが、設定により一つもない場合のチェック
      if (
        config.member_card ||
        config.member_payment ||
        config.member_gender ||
        config.member_age ||
        config.member_decile ||
        config.member_rank ||
        config.member_quantity ||
        config.member_amount ||
        config.member_visit ||
        config.member_gross ||
        config.member_basket
      ) {
        config.member_detail = 1
      } else {
        config.member_detail = 0
      }

      //  共有する
      if (config.output_publish) {
        if (state.is_reservation === 1 && Constants.getContract('reservation_publish_setting_flag') === 1) {
        } else {
          config.output_publish = false
        }
        if (state.is_reservation === 0 && Constants.getContract('history_publish_setting_flag') === 1) {
          config.output_publish = true
        } else {
          config.output_publish = false
        }
      }

      state.analyzeConfig = config
    }
  },
  setTypeMode (state, data) {
    state.condition.type_mode = data
    //  aggregateマスターから必要なcolumnだけの配列を作成
    state.constData.aggregate = _.filter(state.aggregateMaster, (master) => {
      return Constants.AggregateMode[data].some((item) => {
        return master.column === item
      })
    })
  },
  setGroupbyNotice (state, data) {
    state.groupbyNotice = data
  },
  setGroupbyNoticeWithTerm (state, data) {
    state.groupbyNoticeWithTerm = data
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
